import { useNavigate, useLocation } from "react-router-dom";
import CustomTooltip from "./Tooltip";
import { MoreVertical, Share2 } from "lucide-react";
import { useTheme } from "@mui/material/styles";
import { useState } from "react";
import ShareLinkModal from "../chat/ShareChatModel";
import PropTypes from "prop-types";

export default function RenderSideBarItems({
  chat,
  selectedChat,
  handleSelectChat,
  closeSidebar,
  openPopupId,
  setOpenPopupId,
  getLinkShare,
  sharedLink,
  isShowVerticalIcon = true,
  handleSelectProjectChat,
}) {
  const router = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const [shareModalOpen, setShareModalOpen] = useState(false);

  const primaryColor = theme.palette.primary.main;
  const isPopupOpen = openPopupId === chat._id;

  const handleChatClick = () => {

    if (handleSelectProjectChat) {
      handleSelectProjectChat(chat?._id, chat);
      
      router(`/project/${chat.name}/${chat.projectType}/${chat.projectId}/${chat._id}`);
      setOpenPopupId(null);
      closeSidebar();
    } else {
      handleSelectChat(chat?._id, chat);
      router(`/chat/${chat._id}`);
      setOpenPopupId(null);
      closeSidebar();
    }

  };

  return (
    <CustomTooltip
      bgColor={"#000000"}
      textColor={"#ffffff"}
      data-tooltip-id={`${chat._id}-tooltip`}
      data-tooltip-content={chat.title}
      show={true}
    >
      <button
        type="button"
        key={chat._id}
        className={`p-2 ml-4 rounded-lg hover:bg-gray-200 cursor-pointer text-xs text-[#000000] font-hel font-medium flex items-center w-full relative min-w-0 ${selectedChat?._id === chat._id || location.pathname.includes(chat?._id) ? "bg-[#1b5c2926]" : ""
          }`}

        onClick={handleChatClick}
      >
        <span className="truncate text-left flex-1 min-w-0">{chat.title}</span>
        {isShowVerticalIcon && selectedChat?._id === chat._id && (
          <span className="flex-shrink-0 ml-2 flex items-center">
            <MoreVertical
              className="w-5 h-5"
              color={primaryColor}
              onClick={(e) => {
                e.stopPropagation();
                setOpenPopupId(isPopupOpen ? null : chat._id);
              }}
            />
          </span>
        )}
      </button>

      {isPopupOpen && (
        <div className="w-[103px] h-[40px] flex justify-center items-center rounded-lg shadow-md absolute bg-white top-50 right-6 z-50 gap-2 cursor-pointer">
          <Share2 size={18} color="#1B5C29" />
          <button
            className="!text-[#000000]  "
            onClick={(e) => {
              e.stopPropagation();
              getLinkShare();
              setShareModalOpen(true);
            }}
          >
            Share
          </button>
        </div>
      )}
      <ShareLinkModal
        isOpen={shareModalOpen}
        onClose={() => setShareModalOpen(false)}
        sharedLink={sharedLink}
        chatId={chat._id}
      />
    </CustomTooltip>
  );
}


RenderSideBarItems.propTypes = {
  chat: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  selectedChat: PropTypes.object.isRequired,
  handleSelectChat: PropTypes.func.isRequired,
  closeSidebar: PropTypes.func.isRequired,
  openPopupId: PropTypes.string,
  setOpenPopupId: PropTypes.func.isRequired,
  getLinkShare: PropTypes.func.isRequired,
  sharedLink: PropTypes.string,
  handleSelectProjectChat: PropTypes.func
};